import {
    AgileOverviewOneQuery,
    getAgileOverviewQueryVars
} from "@/contentful/graphql";
import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import { init as initRelay } from "../init-relay-streaming";
import { AgileOverviewPage } from "../pages/agile/overview/agile-overview-page";

initRelay(
    AgileOverviewPage,
    AgileOverviewOneQuery,
    getAgileOverviewQueryVars(window.location),
    RELAY_API_CONTENTFUL
);
